// Import general mixin for shared functionality.
import defaultApp from './defaultApp.js';

// Import components for this specific app.
import listItem from './components/ListItem.vue';

// Import DatePicker for dates functionality.
import Datepicker from 'vanillajs-datepicker/Datepicker';
import nl from 'vanillajs-datepicker/locales/nl';
import fr from 'vanillajs-datepicker/locales/fr';
import ar from 'vanillajs-datepicker/locales/ar';
Object.assign(Datepicker.locales, nl, fr, ar);

const datePickerOptions = {
    autohide: true,
    format: 'dd-mm-yyyy',
    nextArrow: '<i class="fa-solid fa-angle-right"></i>',
    prevArrow: '<i class="fa-solid fa-angle-left"></i>',
    orientation: 'bottom',
    clearButton: true
}

const newsApp = {
    ...defaultApp,
    // Overwrite default app functionalities as you please by using the spread operator.
    components: {
        ...defaultApp.components,
        listItem
    },
    data() {
        return {
            ...defaultApp.data(),
            datepicker: null
        }
    },
    computed: {
        ...defaultApp.computed,
        allDays() {
            if (!this.data.facets.length) return [];
            let dateFacet = this.data.facets.find(facet => facet.alias === this.constants.keys.date);
            if (!dateFacet) return [];
            let dates = dateFacet.options.filter(option => option.filteredAmount > 0).map(option => option.valueAlias);
            return dates;
        }
    },
    methods: {
        ...defaultApp.methods,
        setFacets(response) {
            if (!response || response.status != 200 || !response.data.facets) return;
            this.data.facets = response.data.facets
                .sort((a, b) => a.sortOrder - b.sortOrder)
                .map(facet => ({
                    ...facet,
                    values: facet.options.filter(option => option.selected).map(option => option.valueAlias),
                }));
            this.data.queryCount = response.data.queryCount;

            this.$nextTick(() => {
                if (this.datepicker === null && this.$refs.datepicker) {
                    const self = this;
                    datePickerOptions.defaultViewDate = this.filterDate === '' ? this.formatDate(this.allDays[0]) : this.filterDate;
                    datePickerOptions.language = this.language;
                    datePickerOptions.dateDelimiter = this.delimiter;
                    datePickerOptions.format = this.dataCulture === this.constants.culture.dutch ? 'dd-mm-yyyy' : 'dd/mm/yyyy';

                    datePickerOptions.datesDisabled = function (date) {
                        return !self.allDays.includes(new Intl.DateTimeFormat(self.dataCulture, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(date));
                    }
                    const dateInput = document.getElementById('datepickerInput');
                    this.datepicker = new Datepicker(dateInput, datePickerOptions);
                    this.datepicker.setDate(this.filterDate);
                    dateInput.addEventListener('changeDate', (e) => {
                        let filterdate = '';
                        if (e.detail.date !== undefined) {
                            self.filterDate = new Intl.DateTimeFormat('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(self.toDateObj(e.detail.date));
                            filterdate = self.filterDate.replaceAll('/', '-');
                        } else {
                            self.filterDate = '';
                        }
                        const index = self.filterItems.findIndex(item => item.Key === this.constants.keys.date);
                        if (index > -1) {
                            self.filterItems.splice(index, 1);
                        }
                        if (filterdate.length) {
                            self.filterItems.push({ Key: this.constants.keys.date, Values: [filterdate], Operator: this.constants.operators.equals });
                        }
                        self.fetchInitialData(self.queryModel);
                    });
                    dateInput.addEventListener('change', (e) => {
                        if (e.target.value === '') {
                            const index = self.filterItems.findIndex(item => item.Key === this.constants.keys.date);
                            if (index > -1) {
                                self.filterItems.splice(index, 1);
                            }
                            self.filterDate = '';
                            self.fetchInitialData(self.queryModel);
                        }
                    });
                }
            });
        },
        reset() {
            this.data.facets.forEach(facet => facet.values = []);
            this.filterDate = '';
            if (this.datepicker) {
                this.datepicker.setDate(null);
            }
            this.searchText = '';
            this.loading = true;
            this.fetchInitialData();
            this.loading = false;
        },
        formatDate(dateString) {
            return dateString.replaceAll('-', this.delimiter);
        }
    },
};

export default newsApp;
